import { render, staticRenderFns } from "./AddResultModal.vue?vue&type=template&id=06d76cf5&"
import script from "./AddResultModal.vue?vue&type=script&lang=js&"
export * from "./AddResultModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports